import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./private-route";
import { appSlugs, tokenMainKeys } from "../../../utils/constants";
import Home from "../../common-utilities/components/pdf-signature-manager";

const PdfSignatureManagerRoutes = ({
  token = tokenMainKeys.pdfSignatureManager,
  slug = appSlugs.pdfSignatureManager,
}) => {
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={<PrivateRoute token={token} slug={slug} />}
      >
        <Route path="/" element={<Home />} />
      </Route>
    </Routes>
  );
};

export default PdfSignatureManagerRoutes;
